"use client";

import { c as _c } from "react/compiler-runtime";
import { XCircle } from "lucide-react";
import { useTheme } from "next-themes";
import { toast, Toaster as Sonner } from "sonner";
type ToasterProps = React.ComponentProps<typeof Sonner>;
const Toaster = t0 => {
  const $ = _c(8);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  const {
    theme: t1
  } = useTheme();
  const theme = t1 === undefined ? "system" : t1;
  const t2 = theme as ToasterProps["theme"];
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      error: <XCircle className="w-5 h-5" />
    };
    t4 = {
      classNames: {
        toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
        description: "group-[.toast]:text-muted-foreground",
        actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
        cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground"
      }
    };
    t5 = {
      "--success-bg": "#16a34a",
      "--success-border": "#15803d",
      "--success-text": "#ffffff",
      "--error-bg": "#dc2626",
      "--error-border": "#b91c1c",
      "--error-text": "#ffffff",
      "--info-bg": "#eab308",
      "--info-border": "#ca8a04",
      "--info-text": "#ffffff"
    };
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== props || $[6] !== t2) {
    t6 = <Sonner theme={t2} className="toaster group" richColors={true} icons={t3} toastOptions={t4} style={t5 as React.CSSProperties} {...props} />;
    $[5] = props;
    $[6] = t2;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};
export { Toaster, toast };